export function zobrazDataZLocalStorage() {
    // Načíta položky z localStorage
    var entries = JSON.parse(localStorage.getItem("allEntries"));
    
    // Ak existujú položky, vypíše ich do konzoly
    if (entries) {
        console.log("Položky v localStorage:");
        entries.forEach((entry, index) => {
            console.log(`Položka ${index + 1}:`, entry);
        });
    } else {
        console.log("Žiadne položky v localStorage.");
    }
}


export function exportAndShareCSV() {
    // Načíta položky z localStorage
    var entries = JSON.parse(localStorage.getItem("allEntries"));
    var myDate = localStorage.getItem("myDate"); // Načítanie myDate z localStorage
    var discountInput = localStorage.getItem("discountInput") || "0"; // Načítanie discountInput z localStorage, ak je prázdny, nastavíme na 0

    if (!entries || entries.length === 0) {
        console.log("Žiadne položky v localStorage.");
        return;
    }

    // Získanie názvu súboru alebo použitie predvoleného názvu
    var fileName = (myDate || 'data') + ".csv";

    // Vytvorenie obsahu CSV
    var csvContent = "ID,Amount,Quantity,Total,QuantityKS,CardTitle,CardTitle2,Unit,Date,Discount\n";

    // Pridanie údajov z localStorage do CSV obsahu
    entries.forEach(entry => {
        var row = [
            entry.id,
            entry.amount,
            entry.quantity,
            entry.total,
            entry.quantityKS,
            entry.cardtitle ? entry.cardtitle.replace(/,/g, "") : "", // Zbavenie sa čiarky v textoch
            entry.cardtitle2 ? entry.cardtitle2.replace(/,/g, "") : "", // Zbavenie sa čiarky v textoch
            entry.unit,
            myDate,
            discountInput
        ].join(",");
        csvContent += row + "\n";
    });

    // Vytvorenie Blob objektu pre CSV obsah
    var blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    var file = new File([blob], fileName, { type: 'text/csv' });

    // Skontroluje, či zariadenie podporuje Web Share API
    if (navigator.share) {
        navigator.share({
            title: myDate ? `CSV Data - ${myDate}` : 'CSV Data', // Pridanie myDate do title
            text: 'DiPrclst data CVS',
            files: [file], // Zdieľanie súboru
        }).then(() => {
           // console.log('CSV úspešne zdieľané.');
        }).catch((error) => {
           // console.error('Zdieľanie zlyhalo:', error);
        });
    } else {
        console.log('Web Share API nie je podporované na tomto zariadení.');
    }
}



// Funkcia na exportovanie údajov z localStorage do CSV
function exportToCSV() {

    
    // Načíta položky z localStorage
    var entries = JSON.parse(localStorage.getItem("allEntries"));
    var myDate = localStorage.getItem("myDate"); // Načítanie myDate z localStorage
    var discountInput = localStorage.getItem("discountInput") || "0"; // Načítanie discountInput z localStorage, ak je prázdny, nastavíme na 0

    

    // Kontrola, či existuje myDate
    if (myDate) {
        // Vytvorenie názvu súboru z textového poľa
        document.getElementById("csvFileName").value = myDate;

    }
    
    
    if (!entries || entries.length === 0) {
        console.log("Žiadne položky v localStorage.");
        return;
    }

    // Získanie názvu súboru z inputu alebo použitie predvoleného názvu
    var fileName = document.getElementById("csvFileName").value || "";
    fileName = fileName.trim() + ".csv"; // Odstráni prázdne medzery a pridá príponu .csv

    // Vytvorenie hlavičky CSV súboru
    var csvContent = "ID,Amount,Quantity,Total,QuantityKS,CardTitle,CardTitle2,Unit,Date,Discount\n";
    
    // Pridanie údajov z localStorage do CSV obsahu
    entries.forEach(entry => {
        var row = [
            entry.id,
            entry.amount,
            entry.quantity,
            entry.total,
            entry.quantityKS,
            entry.cardtitle ? entry.cardtitle.replace(/,/g, "") : "", // Zbavte sa čiarky v textoch
            entry.cardtitle2 ? entry.cardtitle2.replace(/,/g, "") : "", // Zbavte sa čiarky v textoch
            entry.unit,
            myDate,
            discountInput
        ].join(",");
        csvContent += row + "\n";
    });

    // Vytvorenie súboru pre stiahnutie
    var blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    var link = document.createElement("a");
    link.setAttribute("href", URL.createObjectURL(blob));
    link.setAttribute("download", fileName); // Použitie zvoleného názvu súboru
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    
}

// Pridanie event listenera na tlačidlo btnSaveCVS
document.getElementById("btnSaveCVS").addEventListener("click", exportToCSV);

// Zobrazenie/skrytie inputu na import CSV po kliknutí na "importcvs"
document.getElementById("importcvs").addEventListener("click", function() {
    const showImportCVSinput = document.getElementById("showImportCVSinput");
    if (showImportCVSinput.style.display === "flex") {
        showImportCVSinput.style.display = "none"; // Skryť div
    } else {
        showImportCVSinput.style.display = "flex"; // Zobraziť div
    }
});




// Funkcia na čítanie CSV a importovanie do localStorage
function importCSV() {
    var fileInput = document.getElementById("csvFileInput");
    var file = fileInput.files[0];
    
    if (!file) {
        alert("Prosím, vyberte CSV súbor.");
        return;
    }

    var reader = new FileReader();
    reader.onload = function(e) {
        var csvContent = e.target.result;
        var rows = csvContent.split("\n"); // Rozdelí riadky CSV
        
        // Prvá riadok je hlavička, preskočíme ju
        var data = [];
        let myDate; // Premenná pre uloženie myDate z CSV
        let discountInput; // Premenná pre uloženie discountInput z CSV
        
        for (var i = 1; i < rows.length; i++) {
            var row = rows[i].split(",");
            
            if (row.length >= 8) { // Očakávame 8 stĺpcov
                if (i === 1) {
                    myDate = row[8].trim(); // Získame myDate z 9. stĺpca (index 8)
                    discountInput = row[9].trim(); // Získame discountInput z 10. stĺpca (index 9)
                }
                var entry = {
                    id: row[0].trim(),
                    amount: parseFloat(row[1].trim()),
                    quantity: parseFloat(row[2].trim()),
                    total: parseFloat(row[3].trim()),
                    quantityKS: row[4].trim(),
                    cardtitle: row[5].trim(),
                    cardtitle2: row[6].trim(),
                    unit: row[7].trim(),
                    date: row[8].trim() // Načítame myDate z CSV
                };
                data.push(entry); // Uložíme jednotlivé záznamy
            }
        }

        // Uloženie dát do localStorage
        localStorage.setItem("allEntries", JSON.stringify(data));
      //  console.log("Údaje boli importované do localStorage:", data);
      // Načítanie myDate a jeho zobrazenie
      if (myDate) {
        localStorage.setItem("myDate", myDate); // Ulož nový myDate z CSV
        document.getElementById("MyDate").innerHTML = myDate; // Zobraz nový myDate
    }
    if (discountInput) {
        localStorage.setItem("discountInput", discountInput); // Ulož nový discountInput z CSV
        document.getElementById("discountInput").innerHTML = discountInput; // Zobraz nový myDate
        // Tu môžete pridať akúkoľvek logiku pre zobrazenie discountInput v UI, ak je to potrebné
    }

        // Zavoláme funkciu DisplayTable na zobrazenie dát
        DisplayTable();

        // Skrytie importného poľa
        document.getElementById("showImportCVSinput").style.display = "none";
    };

    reader.readAsText(file); // Prečíta súbor ako text
}

// Pridanie event listenera na tlačidlo importCVS
document.getElementById("importCVS").addEventListener("click", importCSV);


export function searchButton() {
    document.getElementById("myInput").focus();
  }

  
export function deleteItems() {
    // Vymaže len konkrétny kľúč "allEntries" z localStorage
    localStorage.removeItem("allEntries");
    localStorage.removeItem("myDate");
    localStorage.removeItem("discountInput");
    const discountInputElement = document.getElementById("discountInput");
    if (discountInputElement) {
        discountInputElement.textContent = '0'; // Nastavíme obsah na prázdny reťazec
    }
    // Vytvorenie nového myDate
    let date = new Date();
    let day = date.getDate().toString().padStart(2, '0');
    let month = (date.getMonth() + 1).toString().padStart(2, '0');
    let year = date.getFullYear();
    let hours = date.getHours().toString().padStart(2, '0');
    let minutes = date.getMinutes().toString().padStart(2, '0');
    let seconds = date.getSeconds().toString().padStart(2, '0');
    let formattedDate = `${day}-${month}-${year}-${hours}${minutes}${seconds}`;

    // Uloženie nového myDate do localStorage
    localStorage.setItem("myDate", formattedDate);
      // Zobrazíme nový myDate v elemente MyDate
      document.getElementById("MyDate").innerHTML = formattedDate;
    
    document.getElementById("result").innerHTML = `
        <div class="row">
            <small class="text-center mt-4">  
            
                Žiadne položky. Najprv stlačte na konkrétnej položke ikonu +. Položku pridáte šípkou v pravo dole.
            </small>
        </div>
    `;

     // Resetuje hodnoty resultAll, resultAllDPH a resultAllsDPH na nulu
     document.querySelector(".resultAll").textContent = "0.00 €";
     document.querySelector(".resultAllDPH").textContent = "0.00 €";
     document.querySelector(".resultAllsDPH").textContent = "0.00 €";


  }

 





// Funkcia na výpočet sumy a aktualizáciu hodnôt
export function calculate() {
    let resultAllElement = document.querySelector('.resultAll');
    let resultAllValue = parseFloat(resultAllElement.textContent) || 0;

    // Získame hodnotu zľavy zo vstupného poľa
    let discountInput = document.getElementById('discountInput');
    let discountValue = parseFloat(discountInput.textContent) || 0;

    // Vypočítame cenu po zľave
    let discountAmount = resultAllValue * (discountValue / 100);
    let priceAfterDiscount = resultAllValue - discountAmount;

    // Zobrazenie výsledku zľavy
    let resultAllZlavaElement = document.querySelector('.resultAllZlava');
    resultAllZlavaElement.textContent = !isNaN(priceAfterDiscount) ? priceAfterDiscount.toFixed(2) + ' €' : '0.00 €';

    // Vypočítame DPH (predpokladáme 20% DPH)
    let dphValue = priceAfterDiscount * 0.20;
    let resultAllDPHElement = document.querySelector('.resultAllDPH');
    resultAllDPHElement.textContent = !isNaN(dphValue) ? dphValue.toFixed(2) + ' €' : '0.00 €';

    // Cena s DPH
    let priceWithDPH = priceAfterDiscount + dphValue;
    let resultAllsDPHElement = document.querySelector('.resultAllsDPH');
    resultAllsDPHElement.textContent = !isNaN(priceWithDPH) ? priceWithDPH.toFixed(2) + ' €' : '0.00 €';
}





// Udalosť pre úpravu zľavy
let discountInput = document.getElementById('discountInput');
if (discountInput) {
    discountInput.addEventListener('input', function () {
        calculate();  // Prepočítanie pri zmene zľavy
    });
}

  // Uloženie údajov do localStorage
export function saveToLocalStorage(key, value) {
    localStorage.setItem(key, JSON.stringify(value));
  }
  
  // Načítanie údajov z localStorage
  export function getFromLocalStorage(key) {
    const storedData = localStorage.getItem(key);
    return storedData ? JSON.parse(storedData) : null;
  }

  function generateId() {
    let entries = JSON.parse(localStorage.getItem("allEntries")) || [];
    return entries.length > 0 ? entries[entries.length - 1].id + 1 : 1;
}

// Funkcia na uloženie dátumu do localStorage, ak ešte neexistuje
function initializeDate() {
    // Kontrola, či je už dátum uložený v localStorage
    let storedDate = localStorage.getItem("myDate");
    if (storedDate) {
        // Ak už existuje dátum, nezmeníme ho a vrátime sa
      //  console.log("Dátum už existuje:", storedDate);
        document.getElementById("MyDate").innerHTML = storedDate; // Zobrazíme už existujúci dátum
        return; // Ak je dátum už uložený, ukončite funkciu
    }

    // Ak neexistuje, nastavíme nový dátum
    let date = new Date();
    let day = date.getDate().toString().padStart(2, '0');
    let month = (date.getMonth() + 1).toString().padStart(2, '0');
    let year = date.getFullYear();
    let hours = date.getHours().toString().padStart(2, '0');
    let minutes = date.getMinutes().toString().padStart(2, '0');
    let seconds = date.getSeconds().toString().padStart(2, '0');
    let formattedDate = `${day}-${month}-${year}-${hours}${minutes}${seconds}`;

    // Uloženie dátumu do localStorage (len raz)
    localStorage.setItem("myDate", formattedDate);
    document.getElementById("MyDate").innerHTML = formattedDate;

    // Kontrola, či je uložený dátum v localStorage
    //console.log("Dátum uložený v localStorage:", localStorage.getItem("myDate")); // Zobrazenie v konzole

     // Kontrola, či je zľava uložená v localStorage
     let storedDiscount = localStorage.getItem("discountInput");
     if (storedDiscount) {
         // Ak už existuje zľava, zobrazíme ju
         document.getElementById("discountInput").innerHTML = storedDiscount; // Zobrazíme už existujúcu zľavu
     } else {
         // Ak neexistuje, nastavíme predvolenú zľavu (napr. 0)
         let defaultDiscount = "0"; // Predvolená zľava
         localStorage.setItem("discountInput", defaultDiscount); // Uložíme do localStorage
         document.getElementById("discountInput").innerHTML = defaultDiscount; // Zobrazíme predvolenú zľavu
     }
}
// Pridajte udalosti pre editable discountInput
document.addEventListener('DOMContentLoaded', function() {
    const discountInput = document.getElementById("discountInput");

    // Uloženie zľavy do localStorage pri strate focusu
    discountInput.addEventListener("blur", function() {
        const value = this.textContent.trim(); // Získame textový obsah a odstránime prázdne medzery
        // Overenie, že je zľava číselná
        if (!isNaN(value) && value !== "") {
            localStorage.setItem("discountInput", value); // Uložíme hodnotu do localStorage
            console.log("Zľava uložená do localStorage:", value); // Pre kontrolu
        } else {
            console.log("Neplatná zľava, neukladáme."); // Pre kontrolu
        }
    });

    // Inicializácia myDate
    initializeMyDate();
});

  // Funkcia na ukladanie údajov do localStorage pri kliknutí na tlačidlo "store"
export function storeButtonHandler(event) {
    event.preventDefault();
    
    // Získanie údajov z inputov
    let amount = parseFloat(document.getElementById("amount").value) || 0;
    let quantity = parseFloat(document.getElementById("quantity").value) || 0;
    let ks = parseFloat(document.getElementById("quantityKS").value) || 1;
    let total = parseFloat(document.getElementById("total").value) || 0;

       
  

    // Získanie hodnoty z aktívneho tlačidla .valueofinput.active
    let activeInput = document.querySelector('.valueofinput.active');
    let pricePerM2 = activeInput ? parseFloat(activeInput.getAttribute('value')) : 0;

    if (pricePerM2 === 0) {
       // console.warn("Hodnota tlačidla valueofinput.active nie je dostupná alebo je neplatná.");
        return; // Ak cena nie je dostupná, neuložíme položku
    }

   // Načítanie existujúcich položiek z localStorage
let entriesAlert = JSON.parse(localStorage.getItem("allEntries")) || [];

// Načítame order number z localStorage
let storedOrderNumber = localStorage.getItem("orderNumber");

// Ak je v localStorage uložené číslo objednávky, ktoré je už overené ako platné:
if (storedOrderNumber) {
   // console.log(`Platné číslo objednávky: ${storedOrderNumber}. Povolený neobmedzený počet položiek.`);
    // Tu nie je potrebné overovať, len priamo umožníme neobmedzený počet položiek.
} else {
    // Ak nie je číslo objednávky uložené, kontrolujeme počet položiek (limit na 5)
    if (entriesAlert.length >= 4) {
        displayMessage("Dosiahli ste maximálny počet položiek (4), ktoré môžete pridať do cenníka v nezakúpenej verzii");
        return; // Ukončenie funkcie, nepovolí ďalší zápis
    }
}
 
    //  // Kontrola, či už existuje viac ako 5 položiek limit
    //  if (entriesAlert.length >= 5) {    
    //     displayMessage("Dosiahli ste maximálny počet položiek (5), ktoré môžete uložiť v nezakúpenej verzii"); // Zobrazenie správy
    //     return; // Ukončenie funkcie, nepovolí ďalší zápis
    // }
    

    // Vytvorenie novej položky
    let newItem = {    
        id: generateId(),
        amount: amount,
        quantity: quantity,
        total: total,
        quantityKS: ks,
        cardtitle: document.querySelector('.valueofinput.active').getAttribute('card-title'),
        cardtitle2: document.querySelector('.valueofinput.active').getAttribute('card-title2'),
        unit: document.querySelector('.valueofinput.active').getAttribute('unit')
    };

    // Načítanie existujúcich položiek z localStorage
    let entries = JSON.parse(localStorage.getItem("allEntries")) || [];
    entries.push(newItem);

    // Uloženie položiek do localStorage
    localStorage.setItem("allEntries", JSON.stringify(entries));

    

    const movedArrow = document.querySelector(".movedArrow");
    movedArrow.style.display = "block";
    movedArrow.style.left = "-5px";
    setTimeout(() => {
        movedArrow.style.display = "none";
        movedArrow.style.left = "-12px";
    }, 500);

    const resultAll = document.querySelector(".resultAll");
    resultAll.style.display = "none";
    setTimeout(() => {
        resultAll.style.display = "block";
    }, 300);

    const mainPlusButton = document.querySelector(".mainplus");
    const originalColor = mainPlusButton.style.backgroundColor;
    mainPlusButton.style.backgroundColor = "red";
    mainPlusButton.classList.add("shake");
    setTimeout(() => {
        mainPlusButton.style.backgroundColor = originalColor;
        mainPlusButton.classList.remove("shake");
    }, 500);

    DisplayTable();
    spocitadloTotal();
    calculate(); 
    
}



function displayMessage(message) {
    const messageDiv = document.getElementById("message");
    messageDiv.innerText = message;
    messageDiv.style.display = "block"; // Zobrazenie správy
    setTimeout(() => {
        messageDiv.style.display = "none"; // Skrytie správy po 3 sekundách
    }, 3000); // Čas na zobrazenie správy (3000 ms = 3 sekundy)
}



  // Funkcia na načítanie uložených údajov pri načítaní stránky
  export function loadStoredItems() {
    const storedItem = getFromLocalStorage('storedItem');
    if (storedItem) {
      document.getElementById("amount").value = storedItem.width;
      document.getElementById("quantity").value = storedItem.height;
      document.getElementById("quantityKS").value = storedItem.ks;
      document.getElementById("total").value = storedItem.total;
      document.getElementById("totalM2").value = storedItem.total;
    }
  }
  
  

  export function DisplayTable() {
    var result = document.getElementById("result");
    result.innerHTML = "";
    var entries = JSON.parse(localStorage.getItem("allEntries"));
    if (entries === null) {
        result.innerHTML = `
            <div class="card-body row">
                <small class="text-center mt-4">
                
                    Žiadne položky. Najprv stlačte na konkrétnej položke ikonu +. Položku pridáte šípkou vpravo dole.
                </small>
            </div>
        `;
    } else {
        entries.forEach(function(entry) {
            // Podmienka na zobrazenie amount a quantity len pre cm alebo mm
            let dimensions = '';
            if (entry.unit === 'm2') {
                dimensions = `${entry.amount}x${entry.quantity} cm ${entry.quantityKS} ks`;
            }
            if (entry.unit !== 'm2') {
                // Kód pre prípad, keď unit nie je 'm2'
                dimensions = `${entry.quantityKS} ${entry.unit}`;
            }

            result.insertAdjacentHTML("beforeend", `
            <div class="card-body row">
                <div class="col-9">
                    <h5 class="card-title mb-1 mt-1 editable" contenteditable="true" data-id="${entry.id}" data-field="cardtitle2">
                        ${entry.cardtitle2 || 'Kliknite sem a pridajte titul'}
                    </h5>
                    <h6 class="editable" contenteditable="true" data-id="${entry.id}" data-field="cardtitle">
                        ${entry.cardtitle || 'Kliknite sem a pridajte titul'}
                    </h6>
                    <small class="card-subtitle">${dimensions}</small>
                </div>
                <div class="col-2 d-flex justify-content-end align-items-center">
                    <br>
                    <span class="spocitadlo">${entry.total}</span> €
                </div>
                <div class="col-1 d-flex justify-content-between align-items-center">
                    <button data-id="${entry.id}" class="btn btn-close btn-outline-danger btn-sm delete"></button>
                </div>
            </div>
        `);
    });

        

        var deleteButtons = document.querySelectorAll(".delete");
        deleteButtons.forEach(button => {
            button.addEventListener("click", function() {
                // Logovanie informácií o kliknutí
               // console.log("Tlačidlo mazania kliknuté.");
        
                // Získanie ID z atribútu
                const id = parseInt(this.getAttribute("data-id"), 10);
               // console.log("ID položky na mazanie:", id); // Logovanie ID položky
        
                // Zavolajte funkciu na mazanie
                getId(id);
            });
        });


         // Pridajte udalosti pre editovateľné tituly
         var editableTitles = document.querySelectorAll(".editable[contenteditable='true']");
         editableTitles.forEach(title => {
             title.addEventListener("blur", function() {
                 const id = parseInt(this.getAttribute("data-id"), 10);
                 const field = this.getAttribute("data-field");
                 const value = this.innerText.trim();
                 if (field === "cardtitle2") {
                     updateCardTitle2(id, value); // Update for h5 title
                 } else {
                     updateCardTitle(id, value); // Update for h6 title
                 }
             });
         });
    }

    spocitadloTotal();
}



// Funkcia na aktualizáciu názvu karty pre h6
function updateCardTitle(id, cardtitle) {
    var entries = JSON.parse(localStorage.getItem("allEntries")) || [];
    var entry = entries.find(e => e.id === id);
    if (entry) {
        entry.cardtitle = cardtitle; // Aktualizuj názov karty
        localStorage.setItem("allEntries", JSON.stringify(entries)); // Ulož aktualizovaný zoznam
        console.log(`Názov karty (h6) aktualizovaný pre ID ${id}: ${cardtitle}`);
    }
}

// Funkcia na aktualizáciu názvu karty pre h5
function updateCardTitle2(id, cardtitle2) {
    var entries = JSON.parse(localStorage.getItem("allEntries")) || [];
    var entry = entries.find(e => e.id === id);
    if (entry) {
        entry.cardtitle2 = cardtitle2; // Aktualizuj názov karty (h5)
        localStorage.setItem("allEntries", JSON.stringify(entries)); // Ulož aktualizovaný zoznam
        console.log(`Názov karty (h5) aktualizovaný pre ID ${id}: ${cardtitle2}`);
    }
}

//#myDate

// Funkcia na aktualizáciu myDate v localStorage
function updateMyDate() {
    const myDateElement = document.getElementById("MyDate");
    const newValue = myDateElement.innerText.trim(); // Získa text z editovateľného poľa

    // Uloženie nového textu do localStorage
    localStorage.setItem("myDate", newValue);
    //console.log("Nová hodnota myDate uložená v localStorage:", newValue);
}

// Funkcia na inicializáciu myDate z localStorage pri načítaní stránky
function initializeMyDate() {
    let storedDate = localStorage.getItem("myDate");
    const myDateElement = document.getElementById("MyDate");

    if (storedDate) {
        myDateElement.innerText = storedDate; // Zobrazíme existujúci text
       // console.log("Načítaný myDate z localStorage:", storedDate);
    } else {
         // Ak neexistuje, vytvoríme a uložíme aktuálny dátum
         let date = new Date();
         let day = date.getDate().toString().padStart(2, '0');
         let month = (date.getMonth() + 1).toString().padStart(2, '0');
         let year = date.getFullYear();
         let hours = date.getHours().toString().padStart(2, '0');
         let minutes = date.getMinutes().toString().padStart(2, '0');
         let seconds = date.getSeconds().toString().padStart(2, '0');
         let formattedDate = `${day}-${month}-${year}-${hours}${minutes}${seconds}`;
 
         // Uloženie nového myDate do localStorage
         localStorage.setItem("myDate", formattedDate);
         myDateElement.innerText = formattedDate; // Zobrazíme nový dátum
    }
    // Načítanie zľavy
    let storedDiscount = localStorage.getItem("discountInput");
    const discountElement = document.getElementById("discountInput");

    if (storedDiscount) {
        discountElement.innerText = storedDiscount; // Zobrazíme existujúcu zľavu
        //console.log("Načítaná zľava z localStorage:", storedDiscount);
    } else {
        discountElement.innerText = "0"; // Predvolené nastavenie zľavy na 0
        localStorage.setItem("discountInput", "0"); // Uložíme predvolenú zľavu do localStorage
        //console.log("Zľava neexistovala, nastavili sme na 0.");
    }
}

// Načítanie funkcie pri načítaní stránky
document.addEventListener('DOMContentLoaded', initializeMyDate);

// Pridanie udalosti pre editovateľný prvok myDate
const myDateElement = document.getElementById("MyDate");
myDateElement.addEventListener("blur", updateMyDate); // Uloží nový text pri opustení poľa



export function getId(id) {
    // Získaj všetky položky z LocalStorage
    let entries = JSON.parse(localStorage.getItem("allEntries"));

   // console.log("Existujúce položky pred mazáním:", entries);
    
    if (entries === null) {
        console.error("No entries found in localStorage.");
        return;
    }

    // Filtruj položky a odstráň tú s daným ID
    let updatedEntries = entries.filter(entry => entry.id.toString() !== id.toString());
    
   // console.log("Položky po mazání:", updatedEntries); // Logovanie po mazani

    // Ulož aktualizovaný zoznam do LocalStorage
    localStorage.setItem("allEntries", JSON.stringify(updatedEntries));
    
    // Aktualizuj zobrazenie položiek
    DisplayTable();
    spocitadloTotal();
    calculate();  // Prepočítaj zľavu a DPH po odstránení položky
}



function updateResultAll(total) {
    // Vyber oba elementy, ktoré obsahujú triedu .resultAll
    const resultElements = document.querySelectorAll(".resultAll");

    // Iteruj cez všetky elementy s triedou .resultAll a aktualizuj ich obsah
    resultElements.forEach(element => {
        element.textContent = total.toFixed(2) + " €";
    });
    calculate();
}

export function spocitadloTotal() {
    var total = 0;
    var spocitadla = document.querySelectorAll(".spocitadlo");
    for (var i = 0; i < spocitadla.length; i++) {
        total += parseFloat(spocitadla[i].textContent);
    }
    updateResultAll(total);
    document.querySelector(".resultAll").textContent = total.toFixed(2) + " €";
    document.querySelector(".resultAllDPH").textContent = (0.2 * total).toFixed(2) + " €";
    document.querySelector(".resultAllsDPH").textContent = (total + 0.2 * total).toFixed(2) + " €";
}
  
export function calc() {
    let amount = parseFloat(document.getElementById("amount").value) || 0;
    let quantity = parseFloat(document.getElementById("quantity").value) || 0;
    let ks = parseFloat(document.getElementById("quantityKS").value) || 1;
    
    // Získanie hodnoty z aktívneho tlačidla .valueofinput.active
    let activeInput = document.querySelector('.valueofinput.active');
    let pricePerM2 = activeInput ? parseFloat(activeInput.getAttribute('value')) : 0;

    if (pricePerM2 === 0) {
        console.warn("Hodnota tlačidla valueofinput.active nie je dostupná alebo je neplatná.");
    }

    // Výpočet celkovej ceny
    let total = (amount * quantity * ks * pricePerM2 / 10000).toFixed(2);

    // Nastavenie hodnoty do poľa 'total'
    document.getElementById("total").value = total;
}

export function calcKS() {
    let ks = parseFloat(document.getElementById("quantityKS").value) || 1;
    let amount = parseFloat(document.getElementById("amount").value) || 0;
    let quantity = parseFloat(document.getElementById("quantity").value) || 0;

    // Získanie hodnoty z aktívneho tlačidla .valueofinput.active
    let activeInput = document.querySelector('.valueofinput.active');
    let pricePerM2 = activeInput ? parseFloat(activeInput.getAttribute('value')) : 0;

    if (pricePerM2 === 0) {
        console.warn("Hodnota tlačidla valueofinput.active nie je dostupná alebo je neplatná.");
    }

    // Výpočet celkovej ceny
    let total = (amount * quantity * ks * pricePerM2 / 10000).toFixed(2);

    // Nastavenie hodnoty do poľa 'total'
    document.getElementById("total").value = total;
}


  // Funkcia na vyčistenie vstupu pri kliknutí
function clearInputOnClick(inputId) {
    document.getElementById(inputId).addEventListener('click', function() {
        this.value = ""; // Vyčistí obsah poľa
    });
}

// Nastavenie event listenerov pre vstupy amount, quantity a quantityKS
clearInputOnClick("amount");
clearInputOnClick("quantity");
clearInputOnClick("quantityKS");
  